import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap"
import Tabs from "src/components/Common/UI/Tabs/Tabs"

const PhoneCenterHeaders = () => {
  const { t } = useTranslation();

  const tabList = [
    {name: "Τηλεφωνικά Κέντρα", path: "/configuration/phonecenters"}, 
  ]
  
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="mb-3">
          <span className="h1">{t("Τηλεφωνικά Κέντρα")}</span>
        </Col>
        <Col xs={12}>
          <Tabs tabList={tabList} />
        </Col>
      </Row>
    </Container>
  )
}

export default PhoneCenterHeaders;
